export enum ImplementAccountingCanIds {
  Spe = 'Spe',
  Sli = 'Sli',
  ENG_Tor = 'ENG_Tor',
  ENG_Spe = 'ENG_Spe',
  ENG_FueRat = 'ENG_FueRat',
  RPTO_Spe = 'RPTO_Spe',
  FPTO_Spe = 'FPTO_Spe',
  RHitch_Pos = 'RHitch_Pos',
  Rear_Draft = 'Rear_Draft',
  Rear_NForce = 'Rear_NForce',
  FHitch_Pos = 'FHitch_Pos',
  Front_Draft = 'Front_Draft',
  Front_NForce = 'Front_NForce',
  WB_Speed = 'WB_Speed',
  GB_Speed = 'GB_Speed',
  GPS_Speed = 'GPS_Speed',

  A1 = 'A1',
  A2 = 'A2',
  A3 = 'A3',
  A4 = 'A4',
  D1 = 'D1',
  D2 = 'D2',
  D3 = 'D3',
  D4 = 'D4',
  C1 = 'C1',
  C2 = 'C2',

  ApplSlu = 'ApplSlu',
  ApplAci = 'ApplAci',
  ApplAdd = 'ApplAdd',
  PHSlu = 'PHSlu',

  Chop_Act = 'Chop_Act',
  Thresh_Drum = 'Thresh_Drum',
  Cutter_State = 'Cutter_State',

  Yield_Act = 'Yield_Act',
  Yield_Mois = 'Yield_Mois',

  ApplRate_Setp = 'ApplRate_Setp',
  FlowRate = 'FlowRate',

  AUX0_Ext_Fl = 'AUX0_Ext_Fl',
  AUX0_Ret_Fl = 'AUX0_Ret_Fl',
  AUX1_Ext_Fl = 'AUX1_Ext_Fl',
  AUX1_Ret_Fl = 'AUX1_Ret_Fl',
  AUX2_Ext_Fl = 'AUX2_Ext_Fl',
  AUX2_Ret_Fl = 'AUX2_Ret_Fl',
  AUX3_Ext_Fl = 'AUX3_Ext_Fl',
  AUX3_Ret_Fl = 'AUX3_Ret_Fl',
  AUX4_Ext_Fl = 'AUX4_Ext_Fl',
  AUX4_Ret_Fl = 'AUX4_Ret_Fl',
}
